import { Injectable } from '@angular/core';
import _ from 'lodash';
import { EmployeeInfoService } from '../../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../../core/services/portal-settings.service';
import { TimeParserService } from '../../../../core/services/time-parser.service';
import { CrewTimecardDataService } from './crew-timecard-data.service';

@Injectable({
  providedIn: 'root'
})

/** Class performs all data manipulations relating to the crew timecard grid data */
export class CrewTimecardManagerService {
  crewTimecardDataService: CrewTimecardDataService;
  employeeInfo: any;
  portalSettings: any;
  timeParserService: TimeParserService;

  originalData: any;
  modifiedData: any;
  rowPropertyNames: any[];
  columnPropertyNames: any[];
  valuePropertyNames: any[];
  columns: any[];
  columnMap: any;
  columnMapKeyArr: any[];
  rows: any[];
  sharedColumnInfo: {};
  currentEmployeeColumns: any;
  dailyTimeByEmployee: any;
  namesToExclude: string[];
  columnsForDR: any[];
  dataTable: any;
  gridData: any;
  lastID: any;
  largestSortID: number;
  udSortUsed: boolean;
  time24HourMode: boolean;
  showEquipment: boolean;    

  constructor(
    crewTimecardDataService: CrewTimecardDataService,
    employeeInfoService: EmployeeInfoService,
    portalSettingsService: PortalSettingsService,
    timeParserService: TimeParserService
  ) {

    this.crewTimecardDataService = crewTimecardDataService;
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.timeParserService = timeParserService;

    this.originalData = {};
    this.modifiedData = {};
    this.rowPropertyNames = [];
    this.columnPropertyNames = [];
    this.valuePropertyNames = [];
    this.columns = [];
    this.columnMap = {};
    this.columnMapKeyArr = [];
    this.rows = [];
    this.sharedColumnInfo = {};
    this.currentEmployeeColumns;
    this.dailyTimeByEmployee;
    this.namesToExclude = ["@KeyID", "@IsReadOnly", "@DateSubmitted", "@IsApproved", "@IsSubmitted", "@PendingStatus", "@IsDelete", "IsRowAggregate", "@IsLocked"];
    this.columnsForDR = [];
    this.gridData = null;
    this.lastID = null;
    this.largestSortID = 0;
    this.udSortUsed = false;
    this.time24HourMode = this.portalSettings.Timecard24Hours.ConfigValue == "1";
    this.showEquipment = this.portalSettings.DTRShowEquipment.ConfigValue == "1";

  }

  //get functions
  getChangedData(dataTable) {
    let allowZeroLine = this.portalSettings["AllowZeroHourCrewLine"].ConfigValue == "1";
    let changedRowsByRowId = {};
    dataTable.eachRow((gridRowId) => {
      let row = dataTable.getItem(gridRowId);
      if (this.crewTimecardDataService.usageMode != "approval" || (row.PendingStatus == "U" && row.IsRowAggregate != true)) {
        let oldColumnCollection = row.isNewRow ? null : this.getColumnCollectionByRowValues(this.originalData.TimecardData, row['___ColumnCollection']);
        $.each(this.columnMap, (resolvedColumnName: string, columnMetadata) => {
          let newValue = row[resolvedColumnName];
          let oldValue = row.isNewRow === true ? null : this.getColumnPropertyValue(oldColumnCollection, resolvedColumnName, columnMetadata.valuePropertyName);
          let keyIds = row.isNewRow ? '-1' : this.getColumnPropertyValue(oldColumnCollection, resolvedColumnName, '@KeyID');
          if (keyIds.constructor === Array) {
            $.each(keyIds, (key, keyId) => {
              if (resolvedColumnName.indexOf("Hours") > -1) {
                if (oldValue !== "" && oldValue != null) {
                  oldValue = parseFloat(oldValue);
                }
                if (newValue !== "" && newValue != null) {
                  newValue = parseFloat(newValue);
                }
              }
              else if (resolvedColumnName.indexOf("StartTime") > -1 && oldValue != null && oldValue.length > 8) {
                if (oldValue !== "" && oldValue != null) {
                  oldValue = this.parseTime(oldValue, "StartTime");
                }
              }
              else if (resolvedColumnName.indexOf("StopTime") > -1 && oldValue != null && oldValue.length > 8) {
                if (oldValue !== "" && oldValue != null) {
                  oldValue = this.parseTime(oldValue, "StopTime");
                }
              }
              let valueChanged = false;
              valueChanged = (row.isNewRow || row.headerModified)
                ? newValue != null && newValue.toString().length > 0 && newValue != "null"
                : (newValue !== oldValue);
              //case to handle 0 hour lines
              if (oldValue === "" || oldValue == null) {
                //any case where a value used to exist and a header value changed
                if (row.headerModified && keyId != -1) {
                  valueChanged = true;
                }
                //handling for 0 hour lines

                else if ((newValue === 0 && allowZeroLine) || (newValue !== 0 && newValue != null && newValue != "")) {
                  valueChanged = true;
                }
                else {
                  valueChanged = false;
                }
              }
              if (valueChanged) {

                let columnValues = resolvedColumnName.split('___');
                if (keyId != -1 || ((newValue !== 0 || allowZeroLine) && newValue !== "")) {
                  columnValues.splice(columnValues.length - 1, 1);
                  let uniqueRowId = $.map(this.rowPropertyNames, (rowPropertyName) => {
                    return this.getRowValue(row, rowPropertyName);
                  }).join('___') +
                    '___' + columnValues.join('___');
                  let values = {};
                  if (!changedRowsByRowId[uniqueRowId]) {
                    changedRowsByRowId[uniqueRowId] = {
                      keyId: keyId,
                      values: values
                    };
                    for (let i = 0; i < columnMetadata.columnValues.length; ++i) {
                      let columnPropertyName = this.columnPropertyNames[i];
                      values[columnPropertyName] = columnMetadata.columnValues[i];
                    }
                    //345660 Get visible columns on the Grid.
                    for (let i = 0; i < this.gridData.rowPropertyNames.length; ++i) {
                      let rowPropertyName = this.gridData.rowPropertyNames[i];
                      values[rowPropertyName] = this.getRowValue(row, rowPropertyName);
                    }
                    if (this.rowPropertyNames.indexOf("Type") > -1 && !values.hasOwnProperty("Type")) {
                      values["Type"] = this.getRowValue(row, "Type");
                    }
                  }
                  let propName = columnMetadata.valuePropertyName.substr(1);
                  if (this.crewTimecardDataService.usageMode != "approval" || propName != "Hours" || row.IsRowAggregate != true) {
                    changedRowsByRowId[uniqueRowId].values[columnMetadata.valuePropertyName.substr(1)] = newValue;
                    if (propName == "StartTime" && !changedRowsByRowId[uniqueRowId].values.hasOwnProperty("StopTime")) {
                      changedRowsByRowId[uniqueRowId].values["StopTime"] = row[resolvedColumnName.substr(0, resolvedColumnName.indexOf("@")) + "@StopTime"];
                    }
                    else if (propName == "StopTime" && !changedRowsByRowId[uniqueRowId].values.hasOwnProperty("StartTime")) {
                      changedRowsByRowId[uniqueRowId].values["StartTime"] = row[resolvedColumnName.substr(0, resolvedColumnName.indexOf("@")) + "@StartTime"];
                    }
                  }
                }
              }
            });
          }
          else {
            let keyId = keyIds;
            if (resolvedColumnName.indexOf("Hours") > -1) {
              if (oldValue !== "" && oldValue != null) {
                oldValue = parseFloat(oldValue);
              }
              if (newValue !== "" && newValue != null) {
                newValue = parseFloat(newValue);
              }
            }
            else if (resolvedColumnName.indexOf("StartTime") > -1 && oldValue != null && oldValue.length > 8) {
              if (oldValue !== "" && oldValue != null) {
                oldValue = this.parseTime(oldValue, "StartTime");
              }
            }
            else if (resolvedColumnName.indexOf("StopTime") > -1 && oldValue != null && oldValue.length > 8) {
              if (oldValue !== "" && oldValue != null) {
                oldValue = this.parseTime(oldValue, "StopTime");
              }
            }
            let valueChanged = false;
            valueChanged = (row.isNewRow || row.headerModified)
              ? newValue != null && newValue.toString().length > 0 && newValue != "null"
              : (newValue !== oldValue);
            //case to handle auto 0 population
            if (oldValue === "" || oldValue == null) {
              //any case where a value used to exist and a header value changed
              if (row.headerModified && keyId != -1) {
                valueChanged = true;
              }
              //handling for 0 hour lines
              else if ((newValue === 0 && allowZeroLine) || (newValue !== 0 && newValue != null && newValue != "")) {
                valueChanged = true;
              }
              else {
                valueChanged = false;
              }
            }
            if (valueChanged) {
              let columnValues = resolvedColumnName.split('___');
              if (keyId != -1 || ((newValue !== 0 || allowZeroLine) && newValue !== "")) {
                columnValues.splice(columnValues.length - 1, 1);
                let uniqueRowId = $.map(this.rowPropertyNames, (rowPropertyName) => {
                  return this.getRowValue(row, rowPropertyName);
                }).join('___') +
                  '___' + columnValues.join('___');
                let values = {};
                if (!changedRowsByRowId[uniqueRowId]) {
                  changedRowsByRowId[uniqueRowId] = {
                    keyId: keyId,
                    values: values
                  };
                  for (let i = 0; i < columnMetadata.columnValues.length; ++i) {
                    let columnPropertyName = this.columnPropertyNames[i];
                    values[columnPropertyName] = columnMetadata.columnValues[i];
                  }
                  //345660 Get visible columns on the Grid.
                  for (let i = 0; i < this.gridData.rowPropertyNames.length; ++i) {
                    let rowPropertyName = this.gridData.rowPropertyNames[i];
                    values[rowPropertyName] = this.getRowValue(row, rowPropertyName);
                  }
                  if (this.rowPropertyNames.indexOf("Type") > -1 && !values.hasOwnProperty("Type")) {
                    values["Type"] = this.getRowValue(row, "Type");
                  }
                }
                let propName = columnMetadata.valuePropertyName.substr(1);
                if (this.crewTimecardDataService.usageMode != "approval" || propName != "Hours" || row.IsRowAggregate != true) {
                  changedRowsByRowId[uniqueRowId].values[columnMetadata.valuePropertyName.substr(1)] = newValue;
                  if (propName == "StartTime" && !changedRowsByRowId[uniqueRowId].values.hasOwnProperty("StopTime")) {
                    changedRowsByRowId[uniqueRowId].values["StopTime"] = row[resolvedColumnName.substr(0, resolvedColumnName.indexOf("@")) + "@StopTime"];
                  }
                  else if (propName == "StopTime" && !changedRowsByRowId[uniqueRowId].values.hasOwnProperty("StartTime")) {
                    changedRowsByRowId[uniqueRowId].values["StartTime"] = row[resolvedColumnName.substr(0, resolvedColumnName.indexOf("@")) + "@StartTime"];
                  }
                }
              }
            }
          }
        });
      }
    })
    return changedRowsByRowId;
  }

  getColumnPropertyValue(columnCollection, columnKey, propertyName) {
    let parentObj = columnCollection;
    let columnValues = columnKey.split('___');
    for (let i = 0; i < this.columnPropertyNames.length; ++i) {
      let collection = parentObj[this.columnPropertyNames[i]];
      parentObj = this.getCollectionItemByProperty(collection, '@Value', columnValues[i], this.columnPropertyNames[i]);
    }
    //special case for collection keyIDs for approval
    if (this.crewTimecardDataService.usageMode == "approval" && propertyName == "@KeyID" && parentObj.Value.constructor === Array) {
      let keyIDs = [];
      $.each(parentObj.Value, (key, val) => {
        if (val["@KeyID"] != -1)
          keyIDs.push(val["@KeyID"]);
      });
      return keyIDs;
    }
    return parentObj.Value[propertyName];
  }

  getGridData(timecardData, sharedColumnInfo, payPeriod, dailyTime) {
    let _this = this;
    this.sharedColumnInfo = sharedColumnInfo;

    this.originalData = $.extend(true, {}, timecardData);
    this.modifiedData = timecardData;
    this.dailyTimeByEmployee = dailyTime;

    // This data represents columns, rows, and values picked out by the user
    this.rowPropertyNames = [];
    this.columnPropertyNames = [];
    this.valuePropertyNames = [];

    this.adjustTimecardData(timecardData);

    this.populateRowPropertyNames(timecardData);
    this.populateColumnPropertyNames(timecardData);
    this.populateValuePropertyNames(timecardData);

    this.columns = [];
    this.columnMap = {};
    this.columnMapKeyArr = [];
    this.populateColumnMap(this.getFirstObjectWithName(timecardData, 'ColumnCollection'), this.columnPropertyNames, [], [], []);
    this.addColumnsForRows();
    this.addRemainingColumnGroups(payPeriod);

    this.rows = [];
    this.populateRows(timecardData.TimecardData, this.rowPropertyNames, {}, true, []);

    this.gridData = {
      columnMap: this.columnMap,
      columns: this.columns,
      rows: this.rows,
      rowPropertyNames: this.rowPropertyNames,
      columnPropertyNames: this.columnPropertyNames,
      valuePropertyNames: this.valuePropertyNames,
      getColumnByName: (columnName) => {
        let column = null;
        $.each(_this.columns, (loopColumnIndex, loopColumn) => {
          if (loopColumn.id === columnName) {
            column = loopColumn;
            return false;
          }
        });
        return column;
      }
    }
    return this.gridData;
  }

  //Names simplified from getCrewTimecardRow, RowID, ...
  getRow(gridRowId) {
    let row = this.crewTimecardDataService.dataTable.getItem(gridRowId);
    let columnCollection = this.getColumnCollectionByRowValues(this.modifiedData.TimecardData, row['___ColumnCollection']);
    return columnCollection;
  }

  getRowID(gridRowId) {
    let row = this.crewTimecardDataService.dataTable.getItem(gridRowId);
    let keyID = null;
    let columnCollection = this.getColumnCollectionByRowValues(this.originalData.TimecardData, row['___ColumnCollection']);
    //return the first KeyID
    $.each(this.columnMap, (resolvedColumnName, columnMetadata) => {
      keyID = this.getColumnPropertyValue(columnCollection, resolvedColumnName, '@KeyID');
      if (keyID > 0) {
        return false;
      }
    });
    return keyID;
  }

  getRowIDs(gridRowId, row = null) {
    if (row == null)
      row = this.crewTimecardDataService.dataTable.getItem(gridRowId);
    let columnCollection = this.getColumnCollectionByRowValues(this.originalData.TimecardData, row['___ColumnCollection']);
    let rowIDs = [];
    $.each(this.columnMap, (resolvedColumnName, columnMetadata) => {
      let id = this.getColumnPropertyValue(columnCollection, resolvedColumnName, '@KeyID');
      if (id.constructor === Array) {
        rowIDs = rowIDs.concat(id);
      }
      else if (id != -1)
        rowIDs.push(id);
    });
    return rowIDs;
  }

  getRowValue(rowObj, rowPropertyName) {
    let rowValue = rowObj[rowPropertyName];
    if (typeof rowValue === "string") {
      if (rowPropertyName == "udKDSTrackerID" || this.sharedColumnInfo[rowPropertyName].IsCombo == 1)
        rowValue = rowValue.substr(0, rowValue.indexOf("@"));
      //#305419 Replacing "null" value with empty string.
      if (rowValue == "null") {
        rowValue = "";
      }
    }
    if (this.sharedColumnInfo[rowPropertyName] != null && this.sharedColumnInfo[rowPropertyName].ValidationDataType == "bit" && rowValue == null) {
      rowValue = "N";
    }
    //238738: Ensure that user selection has appropriate format for PostDate
    if (rowPropertyName.indexOf("PostDate") > -1 && rowValue != null && typeof rowValue.getMonth == 'function') {
      let yyyy = rowValue.getFullYear().toString();
      let mm = (rowValue.getMonth() + 1).toString();
      let dd = rowValue.getDate().toString();
      rowValue = yyyy + "/" + mm + "/" + dd;
    }
    return rowValue;
  }

  //functions for preparing grid data
  private adjustTimecardData(timecardData) {
    function mapPropertyValuesToCollections(obj) {
      $.each(obj, (propertyKey, propertyValue) => {
        if (propertyKey == 'ColumnCollection') {
          mapPropertyValuesToCollections(propertyValue);
        } else if (propertyKey[0] != '@' && propertyKey != 'Value') {
          if (!$.isArray(propertyValue)) {
            obj[propertyKey] = [propertyValue];
          }
          $.each(obj[propertyKey], (childIndex, child) => {
            mapPropertyValuesToCollections(child);
          });
        }
      });
    }
    mapPropertyValuesToCollections(timecardData.TimecardData);
  }

  private populateRowPropertyNames(timecardData) {
    this.populatePropertiesArray(timecardData.TimecardData, this.rowPropertyNames, 'ColumnCollection');
  }

  private populateColumnPropertyNames(timecardData) {
    let columnCollection = this.getFirstObjectWithName(timecardData, 'ColumnCollection');
    this.populatePropertiesArray(columnCollection, this.columnPropertyNames, 'Value');
  }

  private populateValuePropertyNames(timecardData) {
    let valuesCollection = this.getFirstObjectWithName(timecardData, 'Value');
    if (valuesCollection.constructor === Array) {
      valuesCollection = valuesCollection[0];
    }
    $.each(valuesCollection, (valuePropertyName: string, valuePropertyValue) => {
      if (this.namesToExclude.indexOf(valuePropertyName) == -1) {
        if (this.crewTimecardDataService.usageMode == "PR") {
          if (valuePropertyName != "@UsageUnits" || this.showEquipment) {
            this.valuePropertyNames.push(valuePropertyName);
          }
        }
        else if (this.crewTimecardDataService.usageMode == "PREQ") {
          if (valuePropertyName == "@UsageUnits") {
            this.valuePropertyNames.push(valuePropertyName);
          }
        }
        else {
          this.valuePropertyNames.push(valuePropertyName);
        }

      }
    });
  }

  populatePropertiesArray(obj, propertiesArr, stopPropertyName) {
    let onlyPropertyName = null;
    $.each(obj, (propertyName, propertyValue) => {
      if (propertyName[0] !== '@') {  // ignore attribute property names
        onlyPropertyName = propertyName;
        return false;
      }
      return true;
    });
    propertiesArr.push(onlyPropertyName);
    if (!obj[onlyPropertyName][0][stopPropertyName]) {
      this.populatePropertiesArray(obj[onlyPropertyName][0], propertiesArr, stopPropertyName);
    }
  }

  populateColumnMap(columnParent, remainingColumnPropertyNames, columnValues, columnDisplayValues, columnValueCounts) {
    if (remainingColumnPropertyNames.length == 0) {
      $.each(this.valuePropertyNames, (valuePropertyNameIndex, valuePropertyName) => {
        let columnKey = columnValues.join('___') + '___' + valuePropertyName;
        this.columnMapKeyArr.push(columnKey);
        this.columnMap[columnKey] = {
          columnValueCounts: columnValueCounts,
          columnDisplayValues: columnDisplayValues,
          columnValues: $.extend([], columnValues),
          valuePropertyName: valuePropertyName,
          resolvedColumnName: columnKey
        };
      });
    } else {
      let columnCollection = columnParent[remainingColumnPropertyNames[0]];
      $.each(columnCollection, (columnIndex, column) => {
        let subColumnValues = $.extend([], columnValues);
        let subColumnDisplayValues = $.extend([], columnDisplayValues);
        let subColumnValueCounts = $.extend([], columnValueCounts);
        subColumnValues.push(column['@Value']);
        subColumnDisplayValues.push(column['@Label']);
        subColumnValueCounts.push(this.getColumnValuesCount(column, this.columnPropertyNames.slice(subColumnValueCounts.length + 1)));
        this.populateColumnMap(column, remainingColumnPropertyNames.slice(1), subColumnValues, subColumnDisplayValues, subColumnValueCounts);
      });
    }
  }

  //TODO - can this method be cleaned up?
  addColumnsForRows() {
    let PRColumnsToIgnore = [];
    if (!this.showEquipment) {
      PRColumnsToIgnore.push("Equipment");
      PRColumnsToIgnore.push("UsageUnits");
      PRColumnsToIgnore.push("EMCo");
    }
    // Add in columns for displaying row names --- first one will be a grouping function unless there is only one row property name
    let rowsToSkip = 0;
    //if approval mode, add approved column first
    let approvalU = "<button class='ja_approveBtn webix_grid_btn btn btn-success'><i class='modus-icons'>check</i></button> "
      + "<button class='ja_rejectBtn webix_grid_btn btn btn-danger'><i class='modus-icons'>close</i></button> "
      + "<button class='ja_undoBtn webix_grid_btn btn' style='transition: none; background-color: #BCBCBC' disabled><i class='modus-icons'>refresh</i></button>";
    let approvalA = "<button class='ja_approveBtn webix_grid_btn btn btn-success'><i class='modus-icons'>check</i></button> "
      + "<button class='ja_rejectBtn webix_grid_btn btn' style='transition: none; background-color: #BCBCBC' disabled><i class='modus-icons'>close</i></button> "
      + "<button class='ja_undoBtn webix_grid_btn btn btn-primary'><i class='modus-icons'>refresh</i></button>";
    let approvalR = "<button class='ja_approveBtn webix_grid_btn btn' style='transition: none; background-color: #BCBCBC' disabled><i class='modus-icons'>check</i></button> "
      + "<button class='ja_rejectBtn webix_grid_btn btn btn-danger'><i class='modus-icons'>close</i></button> "
      + "<button class='ja_undoBtn webix_grid_btn btn btn-primary'><i class='modus-icons'>refresh</i></button>";
    if (this.crewTimecardDataService.usageMode == "approval")
      this.columns.push({
        id: "Approval",
        header: "",
        width: 158,
        template: function (obj) {
          if (obj.IsReadOnly == "1") {
            return "";
          }
          else if (obj.PendingStatus == "A") {
            return approvalA;
          }
          else if (obj.PendingStatus == "R") {
            return approvalR;
          }
          else {
            return approvalU;
          }
        }
      });
    if (this.rowPropertyNames.length >= 2) {
      let colWidth = 150;
      let header = this.rowPropertyNames[0];
      if (this.sharedColumnInfo[this.rowPropertyNames[0]] != null) {
        if (this.crewTimecardDataService.usageMode == "approval")
          colWidth = this.sharedColumnInfo[this.rowPropertyNames[0]].InputLength || 150;
        else
          colWidth = this.sharedColumnInfo[this.rowPropertyNames[0]].InputLength || 150;
        header = this.sharedColumnInfo[this.rowPropertyNames[0]].ColumnLabel;
      }
      rowsToSkip = 1;
      if (this.crewTimecardDataService.usageMode == "approval" && this.rowPropertyNames[0] == "Employee") {
        this.columns.push({
          id: this.rowPropertyNames[0],
          header: header,
          width: colWidth,
          template: "{common.subrow()} #EmployeeLabel#"
        });
      }
      else if (this.crewTimecardDataService.usageMode == "PR") {
        if (header != "JCCo" && header != "Job" && header != "udUM" && header != "RevCode" && PRColumnsToIgnore.indexOf(header) == -1) {
          this.columns.push({
            id: this.rowPropertyNames[0],
            header: header,
            width: colWidth,
            adjust: false
          });
          if (header == "udSort") {
            this.udSortUsed = true;
          }
        }
      }
      else if (this.crewTimecardDataService.usageMode == "PREQ") {
        if (header == "Equipment" || header == "Phase" || header == "udUM" || header == "RevCode" || header == "Memo" || header == "udSort" || header == "UsageUnits") {
          this.columns.push({
            id: this.rowPropertyNames[0],
            header: header,
            width: colWidth,
            adjust: false
          });
          if (header == "udSort") {
            this.udSortUsed = true;
          }
        }
      }
      else {
        this.columns.push({
          id: this.rowPropertyNames[0],
          header: header,
          width: colWidth,
          adjust: false
        });
      }

    }
    $.each(this.rowPropertyNames.slice(rowsToSkip), (rowPropertyNameIndex, rowPropertyName) => {
      //Job Approval
      if (this.crewTimecardDataService.usageMode == "approval") {
        if (rowPropertyName == "Memo") {
          let colWidth = 250;
          let header = rowPropertyName;

          if (this.sharedColumnInfo[rowPropertyName] != null) {
            if (this.crewTimecardDataService.usageMode == "approval")
              colWidth = this.sharedColumnInfo[rowPropertyName].InputLength || 250;
            header = this.sharedColumnInfo[rowPropertyName].ColumnLabel;
          }
          if (header == "udKDSTrackerID")
            header = "Timecard";
          this.columns.push({ id: rowPropertyName, header: header, width: colWidth });
        }
        else {
          if (rowPropertyName != "udSort") {
            let colWidth = 150;
            let header = rowPropertyName;
            if (this.sharedColumnInfo[rowPropertyName] != null) {
              if (this.crewTimecardDataService.usageMode == "approval")
                colWidth = this.sharedColumnInfo[rowPropertyName].InputLength || 150;
              header = this.sharedColumnInfo[rowPropertyName].ColumnLabel;
            }
            if (header == "udKDSTrackerID")
              header = "Timecard";
            this.columns.push({ id: rowPropertyName, header: header, width: colWidth });
          }
        }
      }
      //Field Ticket Payroll
      else if (this.crewTimecardDataService.usageMode == "PR") {
        if (rowPropertyName != "JCCo" && rowPropertyName != "Job" && rowPropertyName != "udUM" && rowPropertyName != "RevCode" && PRColumnsToIgnore.indexOf(rowPropertyName) == -1) {
          let colWidth = 150;
          let header = rowPropertyName;
          if (this.sharedColumnInfo[rowPropertyName] != null) {
            colWidth = this.sharedColumnInfo[rowPropertyName].InputLength || 150;
            header = this.sharedColumnInfo[rowPropertyName].ColumnLabel;
          }
          if (header == "udKDSTrackerID")
            header = "Timecard";
          this.columns.push({ id: rowPropertyName, header: header, width: colWidth });
          if (rowPropertyName == "udSort") {
            this.udSortUsed = true;
          }

        }
      }
      //Field Ticket Equipment
      else if (this.crewTimecardDataService.usageMode == "PREQ") {
        if (rowPropertyName == "Equipment" || rowPropertyName == "Phase" || rowPropertyName == "udUM" || rowPropertyName == "RevCode" || rowPropertyName == "Memo" || rowPropertyName == "udSort" || rowPropertyName == "UsageUnits") {

          let colWidth = 150;
          let header = rowPropertyName;
          if (this.sharedColumnInfo[rowPropertyName] != null) {
            colWidth = this.sharedColumnInfo[rowPropertyName].InputLength || 150;
            header = this.sharedColumnInfo[rowPropertyName].ColumnLabel;
          }
          if (header == "udKDSTrackerID")
            header = "Timecard";
          this.columns.push({ id: rowPropertyName, header: header, width: colWidth });
          if (rowPropertyName == "udSort") {
            this.udSortUsed = true;
          }
        }
      }
      //Grid Timecard
      else {
        if (rowPropertyName == "Memo") {
          let colWidth = 250;
          let header = rowPropertyName;

          if (this.sharedColumnInfo[rowPropertyName] != null) {
            colWidth = this.sharedColumnInfo[rowPropertyName].InputLength || 250;
            header = this.sharedColumnInfo[rowPropertyName].ColumnLabel;
          }
          if (header == "udKDSTrackerID")
            header = "Timecard";
          this.columns.push({ id: rowPropertyName, header: header, width: colWidth });
        }
        else {
          let colWidth = 150;
          let header = rowPropertyName;
          if (this.sharedColumnInfo[rowPropertyName] != null) {
            colWidth = this.sharedColumnInfo[rowPropertyName].InputLength || 150;
            header = this.sharedColumnInfo[rowPropertyName].ColumnLabel;
          }
          if (header == "udKDSTrackerID")
            header = "Timecard";
          this.columns.push({ id: rowPropertyName, header: header, width: colWidth });
        }
      }

    });
  }

  addRemainingColumnGroups(payPeriod) {
    this.columnsForDR = [];
    let multiDayTicketMode = payPeriod.DTRMultiDayMode;
    let totalHeader = this.portalSettings.CrewTotalsHeaderOverride.ConfigValue != null && this.portalSettings.CrewTotalsHeaderOverride.ConfigValue != "" ? this.portalSettings.CrewTotalsHeaderOverride.ConfigValue : "Tot";
    if (this.crewTimecardDataService.usageMode == "approval") {
      this.columns.push({
        id: "Sub Total",
        header: totalHeader,
        adjust: "header",
        width: 50,
        footer: { content: "summFixedColumn" }
      });
    }
    let preqPostDates = [];
    $.each(this.columnMapKeyArr, (columnMapKeyIndex, columnMapKey) => {
      let headers = [];
      let columnMetadata = this.columnMap[columnMapKey];
      let columnName = columnMapKey.substr(columnMapKey.indexOf("@") + 1);
      let widthOverride;
      if (this.crewTimecardDataService.usageMode == "approval")
        widthOverride = this.sharedColumnInfo[columnName].InputLength || 100;
      else
        widthOverride = this.sharedColumnInfo[columnName].InputLength || 100;
      if ((this.crewTimecardDataService.usageMode == "PR" && (columnName == "Hours" || (columnName == "UsageUnits" && this.showEquipment))) || (this.crewTimecardDataService.usageMode == "PREQ" && columnName == "UsageUnits")) {
        let shiftIndex = this.columnPropertyNames.indexOf("Shift");
        let earnCodeIndex = this.columnPropertyNames.indexOf("EarnCode");
        if (this.crewTimecardDataService.usageMode != "PREQ") {
          for (let i = 0; i < columnMetadata.columnValues.length; ++i) {
            //filter out the date headers and well everything else if its PREQ
            if (multiDayTicketMode ||
              columnMetadata.columnDisplayValues[i].indexOf("Mon<") == -1 && columnMetadata.columnDisplayValues[i].indexOf("Tue<") == -1 &&
              columnMetadata.columnDisplayValues[i].indexOf("Wed<") == -1 && columnMetadata.columnDisplayValues[i].indexOf("Thu<") == -1 &&
              columnMetadata.columnDisplayValues[i].indexOf("Fri<") == -1 && columnMetadata.columnDisplayValues[i].indexOf("Sat<") == -1 &&
              columnMetadata.columnDisplayValues[i].indexOf("Sun<") == -1) {
              //lets calculate some width and height!
              let canvas = document.createElement('canvas');
              let ctx = canvas.getContext("2d");
              let width = ctx.measureText(columnMetadata.columnDisplayValues[i]).width;
              let approximateSpace = widthOverride * columnMetadata.columnValueCounts[i];
              let widthRatio = Math.ceil(width / approximateSpace);

              //Actually use it
              if (columnMetadata.columnDisplayValues[i] != null && (columnMetadata.columnDisplayValues[i].indexOf("<br />") != -1 || columnMetadata.columnDisplayValues[i].indexOf(" ") != -1)) {

                if (columnMetadata.columnDisplayValues[i].indexOf("<br />") != -1 && widthRatio == 1) {
                  widthRatio = 2;
                }
                if (multiDayTicketMode)
                  headers.push({ text: columnMetadata.columnDisplayValues[i], css: "multiline", colspan: columnMetadata.columnValueCounts[i], height: 30 * widthRatio });
                else
                  headers.push({ text: columnMetadata.columnDisplayValues[i], css: "multiline", height: 30 * widthRatio });
              }
              else {
                if (multiDayTicketMode)
                  headers.push({ text: columnMetadata.columnDisplayValues[i], css: "multiline", colspan: columnMetadata.columnValueCounts[i] });
                else
                  headers.push({ text: columnMetadata.columnDisplayValues[i], css: "multiline", height: 30 * widthRatio });
              }
            }
          }
        }
        else if (this.crewTimecardDataService.usageMode == "PREQ") {
          if (earnCodeIndex > -1) {
            if (columnMetadata.columnValues[earnCodeIndex] != this.crewTimecardDataService.equipmentDefaultEarnCode) {
              return;
            }
          }
          if (shiftIndex > -1) {
            if (columnMetadata.columnValues[shiftIndex] != this.crewTimecardDataService.equipmentDefaultShift) {
              return;
            }
          }
          if (multiDayTicketMode) {
            if (preqPostDates.indexOf(columnMetadata.columnDisplayValues[0]) > -1)
              return;
            preqPostDates.push(columnMetadata.columnDisplayValues[0]);
            //lets calculate some width and height!
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext("2d");
            let width = ctx.measureText(columnMetadata.columnDisplayValues[0]).width;
            let approximateSpace = widthOverride * columnMetadata.columnValueCounts[0];
            let widthRatio = Math.ceil(width / approximateSpace);
            if (columnMetadata.columnDisplayValues[0].indexOf("<br />") != -1 && widthRatio == 1) {
              widthRatio = 2;
            }
            headers.push({ text: columnMetadata.columnDisplayValues[0], css: "multiline", height: 30 * widthRatio });
          }
        }

        let valuePropertyName = columnMetadata.valuePropertyName.substr(1);
        headers.push(this.sharedColumnInfo[valuePropertyName].ColumnLabel);
        let column: any = {
          id: columnMapKey,
          header: headers,
        }

        column.width = this.sharedColumnInfo[columnName].InputLength || null;

        if (shiftIndex == -1 && earnCodeIndex == -1) {
          this.crewTimecardDataService.alertType = "danger";
          this.crewTimecardDataService.alertMsg = "Payroll timecard requires EarnCode or Shift as a column header.Please modify your Grid Timecard layout.";
        }
        let valueToUse = shiftIndex > -1 ? "Shift" : "EarnCode";
        let displayValue = columnMetadata.columnDisplayValues[this.columnPropertyNames.indexOf(valueToUse)].replace(/<br \/>/g, "").replace(/&nbsp;/g, " ")
        if (this.showEquipment)
          displayValue += " - " + valuePropertyName;

        if (multiDayTicketMode) {
          let dataValueParts = columnMapKey.split('___');
          dataValueParts.shift();
          let dataValue = dataValueParts.join('___');
          this.columnsForDR.map((x) => { return x.DataValue }).indexOf(dataValue);
          if (this.columnsForDR.map((x) => { return x.DataValue }).indexOf(dataValue) == -1) {
            this.columnsForDR.push({ DisplayValue: displayValue, DataValue: dataValue, HeaderLabel: this.sharedColumnInfo[valuePropertyName].ColumnLabel });
          }

        }
        else {
          if (valuePropertyName != "UsageUnits" || this.crewTimecardDataService.usageMode != "PR")
            this.columnsForDR.push({ DisplayValue: displayValue, DataValue: columnMapKey, HeaderLabel: this.sharedColumnInfo[valuePropertyName].ColumnLabel });
        }

        if (columnName == "Hours" || columnName == "UsageUnits") {
          column.footer = { content: "summFixedColumn" };
        }
        this.columns.push(column);
        //if using PREQ, add only first usage units column
        if (this.crewTimecardDataService.usageMode == "PREQ" && this.crewTimecardDataService.equipmentDefaultEarnCode == null && !multiDayTicketMode)
          return false;
      }
      else if (this.crewTimecardDataService.usageMode != "PR" && this.crewTimecardDataService.usageMode != "PREQ") {
        for (let i = 0; i < columnMetadata.columnValues.length; ++i) {
          //lets calculate some width and height!
          let canvas = document.createElement('canvas');
          let ctx = canvas.getContext("2d");
          let width = ctx.measureText(columnMetadata.columnDisplayValues[i]).width;
          let approximateSpace = widthOverride * columnMetadata.columnValueCounts[i];
          let widthRatio = Math.ceil(width / approximateSpace);

          //Actually use it
          if (columnMetadata.columnDisplayValues[i] != null && (columnMetadata.columnDisplayValues[i].indexOf("<br />") != -1 || columnMetadata.columnDisplayValues[i].indexOf(" ") != -1)) {
            headers.push({ text: columnMetadata.columnDisplayValues[i], colspan: columnMetadata.columnValueCounts[i], css: "multiline", height: 60 });
          }
          else
            headers.push({ text: columnMetadata.columnDisplayValues[i], colspan: columnMetadata.columnValueCounts[i], css: "multiline" });

        }
        let valuePropertyName = columnMetadata.valuePropertyName.substr(1);
        headers.push(this.sharedColumnInfo[valuePropertyName].ColumnLabel);
        let column: any = {
          id: columnMapKey,
          header: headers
        }

        column.width = widthOverride || null;
        if (columnName == "Hours" || columnName == "UsageUnits") {
          column.footer = { content: "summFixedColumn" };
        }
        this.columns.push(column);
      }
    });
    if (this.crewTimecardDataService.usageMode != "approval") {
      let approveTemplate = "<button class='approvebtn btn-primary btn' type='button' style='transition: none; width:100%; margin-bottom:3px; padding-bottom:5px;'><i class='modus-icons'>check</i> Approve</button>";
      let bulkEmployeeTemplate = null;
      if (this.crewTimecardDataService.usageMode == "crewtimecard") {
        bulkEmployeeTemplate = "<button class='copybtn btn-warning btn' type='button'; style='transition: none; width:100%; margin-bottom:3px; padding-bottom:5px;'><i class='modus-icons'>file_copy</i> Copy</button>";
      }

      let deleteTemplate = "<button class='delbtn btn-danger btn' type='button' style='transition: none; width:100%; margin-bottom:3px; padding-bottom:5px;'><i class='modus-icons'>close</i> Delete</button>";
      let totalHeader = this.portalSettings.CrewTotalsHeaderOverride.ConfigValue != null && this.portalSettings.CrewTotalsHeaderOverride.ConfigValue != "" ? this.portalSettings.CrewTotalsHeaderOverride.ConfigValue : "Tot";
      if (this.crewTimecardDataService.usageMode != "PREQ") {
        this.columns.push({
          id: "Sub Total",
          header: totalHeader,

          adjust: "header",
          footer: { content: "summFixedColumn" }
        });
      }

      this.columns.push({
        id: "action",
        header: "",
        width: 120,
        template: (obj) => {
          if (obj.IsSubmitted == "1") {
            if (obj.IsApproved == "1" || obj.IsReadOnly == "1" || this.crewTimecardDataService.readOnlyGrid) {
              return "";
            }
            else {
              if (this.crewTimecardDataService.usageMode == "crewtimecard") {
                return approveTemplate;
              }
              else if (this.portalSettings.DTREmpEquReadOnlyOverride.ConfigValue == 1 && (this.crewTimecardDataService.usageMode == "PR" || this.crewTimecardDataService.usageMode == "PREQ")) {
                return deleteTemplate;
              }
              else
                return "";
            }

          }
          else {
            if (obj.IsReadOnly == "1" || this.crewTimecardDataService.readOnlyGrid) {
              return "";
            }
            else {
              return deleteTemplate;
            }

          }
        },
        css: "padding_less"
      });
      if (this.crewTimecardDataService.usageMode == "crewtimecard" && !this.employeeInfo.IsReadOnlyGridTime && this.employeeInfo.IsAuthFMGridTime && !this.crewTimecardDataService.readOnlyGrid) {
        this.columns.push(
          {
            id: "bulkEmployeeSelect",
            header: "",
            width: 110,
            template: (obj) => {
              if (obj.IsSubmitted != "1") {
                return bulkEmployeeTemplate;
              }
              else
                return "";
            },
            css: "padding_less"
          });
      }
    }
    else {
      if (this.portalSettings.JobApprovalSplitButton.ConfigValue == 1) {
        let splitTemplate = "<button class='splitBtn btn-warning btn' type='button' style='transition: none; width:100%; margin-bottom:3px; padding-bottom:5px;'>Duplicate</button>";
        let deleteTemplate = "<button class='delbtn btn-danger btn' type='button' style='transition: none; width:100%; margin-bottom:3px; padding-bottom:5px;'><i class='modus-icons'>close</i> Delete</button>";
        this.columns.push({
          id: "splitAction",
          header: "",
          width: 120,
          template: (obj) => {
            if (this.crewTimecardDataService.usageMode == "approval" && obj.IsLocked == "1") {
              return "";
            }
            if (obj.IsSubmitted == "1") {
              return "";
            }
            else {
              if (obj.IsReadOnly == "1") {
                return "";
              }
              else if (obj.isNewRow) {
                return deleteTemplate;
              }
              else {
                return splitTemplate;
              }

            }
          },
          css: "padding_less"
        });
      }
      let deleteZeroTemplate = "<button class='delzbtn btn-danger btn' type='button' style='transition: none; width:100%; margin-bottom:3px; padding-bottom:5px;'><i class='modus-icons'>close</i> Delete</button>";
      this.columns.push({
        id: "deleteZero",
        header: "",
        width: 120,
        template: (obj) => {
          if (obj.IsDelete == "1" && !obj.isNewRow) {
            return deleteZeroTemplate
          }
          else {
            return ""
          }
        },
        css: "padding_less"
      });

    }

  };

  populateRows(rowContainer, remainingRowPropertyNames, sharedRowProperties, copyingRowProps, propertyValues) {
    if (remainingRowPropertyNames.length == 0) {
      if (rowContainer.ColumnCollection) {
        // Add in shared data for all column values
        sharedRowProperties['___ColumnCollection'] = propertyValues;

        this.populateRows(rowContainer.ColumnCollection, this.columnPropertyNames, sharedRowProperties, false, []);
        if (this.crewTimecardDataService.usageMode == "approval") {
          let employee = sharedRowProperties.Employee != null ? sharedRowProperties.Employee.substr(0, sharedRowProperties.Employee.indexOf("@")) : sharedRowProperties.Employee;
          sharedRowProperties.EmployeeLabel = sharedRowProperties["Employee___@Value"];
          sharedRowProperties.DailyTime = this.dailyTimeByEmployee[employee];
        }
        if (sharedRowProperties.Employee != null && sharedRowProperties.Employee != "" && sharedRowProperties.Employee.substr(0, sharedRowProperties.Employee.indexOf("@") != "")) {
          //filter rows if usage mode is PR or PREQ
          if (this.crewTimecardDataService.usageMode == "PR" && sharedRowProperties.Employee.substr(0, sharedRowProperties.Employee.indexOf("@")) != this.crewTimecardDataService.equipmentEmployee) {
            this.rows.push(sharedRowProperties);
          }
          else if (this.crewTimecardDataService.usageMode == "PREQ" && sharedRowProperties.Employee.substr(0, sharedRowProperties.Employee.indexOf("@")) == this.crewTimecardDataService.equipmentEmployee) {
            this.rows.push(sharedRowProperties);
          }
          else if (this.crewTimecardDataService.usageMode != "PR" && this.crewTimecardDataService.usageMode != "PREQ") {
            this.rows.push(sharedRowProperties);
          }

        }
      } else {
        // Add Rows

        if (rowContainer.Value.constructor === Array) {
          $.each(rowContainer.Value, (containerKey, containerVal) => {
            $.each(this.valuePropertyNames, (valuePropertyNameIndex, valuePropertyName) => {
              let columnValueKey = propertyValues.join('___') + '___' + valuePropertyName;

              //Will only enter once a value is found
              if (sharedRowProperties[columnValueKey] != null && sharedRowProperties[columnValueKey] != "") {
                if (columnValueKey.indexOf("Hours") > 0 && !isNaN(sharedRowProperties[columnValueKey])) {
                  let numVal = parseFloat(sharedRowProperties[columnValueKey]);
                  let newVal = containerVal[valuePropertyName];
                  if (containerVal[valuePropertyName] != null && containerVal[valuePropertyName] != "") {
                    numVal += parseFloat(newVal);
                    sharedRowProperties.IsRowAggregate = true;
                  }

                  sharedRowProperties[columnValueKey] = numVal.toString();
                }
              }
              //Will enter on first value found
              else {
                if (columnValueKey.indexOf("StartTime") > 0) {
                  sharedRowProperties[columnValueKey] = this.parseTime(containerVal[valuePropertyName], "start");
                }
                else if (columnValueKey.indexOf("StopTime") > 0)
                  sharedRowProperties[columnValueKey] = this.parseTime(containerVal[valuePropertyName], "stop");
                else
                  sharedRowProperties[columnValueKey] = containerVal[valuePropertyName];
              }
            });
          });

          sharedRowProperties["KeyID"] = rowContainer.Value[0]["@KeyID"];
          if (this.crewTimecardDataService.usageMode != "approval") {
            sharedRowProperties["IsReadOnly"] = rowContainer.Value[0]["@IsReadOnly"];
            sharedRowProperties["IsApproved"] = rowContainer.Value[0]["@IsApproved"];
            sharedRowProperties["IsSubmitted"] = rowContainer.Value[0]["@IsSubmitted"];
          }
          else {
            sharedRowProperties["PendingStatus"] = rowContainer.Value[0]["@PendingStatus"];
            if (!sharedRowProperties["IsDelete"] || (rowContainer.Value[0]["@IsDelete"] == 1 && sharedRowProperties["IsDelete"] == 0))
              sharedRowProperties["IsDelete"] = rowContainer.Value[0]["@IsDelete"];
            if (!sharedRowProperties["IsLocked"] || (rowContainer.Value[0]["@IsLocked"] == 1 && sharedRowProperties["IsLocked"] == 0))
              sharedRowProperties["IsLocked"] = rowContainer.Value[0]["@IsLocked"];
          }
        }
        else {
          $.each(this.valuePropertyNames, (valuePropertyNameIndex, valuePropertyName) => {
            let columnValueKey = propertyValues.join('___') + '___' + valuePropertyName;
            sharedRowProperties[columnValueKey] = rowContainer.Value[valuePropertyName];
            if (columnValueKey.indexOf("@StartTime") != -1) {
              sharedRowProperties[columnValueKey] = this.parseTime(sharedRowProperties[columnValueKey], "start");
            }
            else if (columnValueKey.indexOf("@StopTime") != -1) {
              sharedRowProperties[columnValueKey] = this.parseTime(sharedRowProperties[columnValueKey], "stop");
            }
          });
          sharedRowProperties["KeyID"] = rowContainer.Value["@KeyID"];
          if (this.crewTimecardDataService.usageMode != "approval") {
            sharedRowProperties["IsReadOnly"] = rowContainer.Value["@IsReadOnly"];
            sharedRowProperties["IsApproved"] = rowContainer.Value["@IsApproved"];
            sharedRowProperties["IsSubmitted"] = rowContainer.Value["@IsSubmitted"];
          }
          else {
            sharedRowProperties["IsReadOnly"] = rowContainer.Value["@IsReadOnly"];
            sharedRowProperties["PendingStatus"] = rowContainer.Value["@PendingStatus"];
            if (!sharedRowProperties["IsDelete"] || (rowContainer.Value["@IsDelete"] == 1 && sharedRowProperties["IsDelete"] == 0))
              sharedRowProperties["IsDelete"] = rowContainer.Value["@IsDelete"];
            if (!sharedRowProperties["IsLocked"] || (rowContainer.Value["@IsLocked"] == 1 && sharedRowProperties["IsLocked"] == 0))
              sharedRowProperties["IsLocked"] = rowContainer.Value["@IsLocked"];
          }
        }


      }
    } else {
      // Add in shared data for all "row" header values
      let rowPropertyName = remainingRowPropertyNames[0];
      let rowCollection = rowContainer[rowPropertyName];
      let count = 0;

      $.each(rowCollection, (rowIndex, row) => {
        if (rowPropertyName == "StartTime" || rowPropertyName == "StopTime") {
          let oldValue = row["@Value"];
          let newValue = this.parseTime(oldValue, rowPropertyName);
          row["@Value"] = newValue;
        }
        let newSharedRowProperties = sharedRowProperties;
        let newPropertyValues = $.extend([], propertyValues);
        newPropertyValues.push(row['@Value']);

        if (copyingRowProps) {
          newSharedRowProperties = $.extend(true, {}, sharedRowProperties);
          if (this.sharedColumnInfo[rowPropertyName] != null && this.sharedColumnInfo[rowPropertyName].IsCombo == 1) {
            newSharedRowProperties[rowPropertyName] = row['@Value'] + "@row_";
          }
          else {
            newSharedRowProperties[rowPropertyName] = row['@Value'];
          }
          newSharedRowProperties[rowPropertyName + '___@Value'] = this.escapeHtml(row['@Label']);
        } else {
          newSharedRowProperties[rowPropertyName] = row['@Value'];
        }
        count++;
        this.populateRows(row, remainingRowPropertyNames.slice(1), newSharedRowProperties, copyingRowProps, newPropertyValues);
      });
    }
  }

  addRows(rows, dataTable, callback) {
    let addedRows = [];
    if (this.lastID == null) {
      this.lastID = 0;
      dataTable.eachRow((id) => {
        this.lastID = Math.max(this.lastID, id);
      });
    }
    this.lastID++;
    rows.forEach((rowToAdd) => {
      let row = _.cloneDeep(rowToAdd);
      row.id = this.lastID;
      $.each(rowToAdd, (key, val) => {
        if (this.rowPropertyNames.indexOf(key) > -1) {
          if (key == "udSort") {
            this.largestSortID++;
            row["udSort"] = this.largestSortID;
          }
          else {
            if (val != null && val != "") {
              if (this.sharedColumnInfo[key].IsCombo == 1)
                row[key] = val + "@row_" + row.id;
              else
                row[key] = val;
            }
            else {
              row[key] = "";
            }
          }


        }

      });
      dataTable.add(row, 0);
      addedRows.push(row);
      this.lastID++;
    });
    callback(addedRows);
  }

  //Helper functions
  private getCollectionItemByProperty(collection, propertyName, propertyValue, columnName) {
    let foundItem = null;
    $.each(collection, (itemIndex, item) => {
      //special handling for start/stop time as shared row value
      if (columnName == "StartTime" || columnName == "StopTime") {
        let value = this.parseTime(item[propertyName], propertyName);
        if (value === propertyValue) {
          foundItem = item;
          return false;
        }
      }
      else {
        if (item[propertyName] === propertyValue) {
          foundItem = item;
          return false;
        }
      }

      return true;
    });
    return foundItem;
  }

  private getColumnCollectionByRowValues(firstRowParent, rowValues) {
    let parentObj = firstRowParent;
    for (let i = 0; i < this.rowPropertyNames.length; ++i) {
      let collection = parentObj[this.rowPropertyNames[i]];
      parentObj = this.getCollectionItemByProperty(collection, '@Value', rowValues[i], this.rowPropertyNames[i]);
    }
    return parentObj.ColumnCollection;
  }


  private getColumnValuesCount(obj, remainingColumnNamesArr) {
    if (remainingColumnNamesArr.length == 0) {
      return this.valuePropertyNames.length;
    }
    let childColumnName = remainingColumnNamesArr[0];
    let subColumnCollection = obj[childColumnName];
    let columnValuesCount = 0;
    $.each(subColumnCollection, (childColumnIndex, childColumn) => {
      columnValuesCount += this.getColumnValuesCount(childColumn, remainingColumnNamesArr.slice(1));
    });
    return columnValuesCount;
  }

  private getFirstObjectWithName(obj, propertyName) {
    if ($.isArray(obj)) return this.getFirstObjectWithName(obj[0], propertyName);
    if (obj[propertyName]) return obj[propertyName];
    let firstObjWithName = null;
    $.each(obj, (key, childObj) => {
      if (key[0] === '@') return true;
      firstObjWithName = this.getFirstObjectWithName(childObj, propertyName);
      return firstObjWithName == null;
    });
    return firstObjWithName;
  }

  parseTime(value, mode) {
    if (value != null && value != "") {
      if (value.length > 8) {
        value = value.substr(value.lastIndexOf(" ") + 1);
      }
      let timeStr = value;
      timeStr = timeStr.trim().replace(" ", "");
      let timeOfDay = timeStr.toUpperCase().indexOf('A') != -1
        ? 'AM'
        : timeStr.toUpperCase().indexOf('P') != -1
          ? 'PM' : null;
      //detect non-colon time
      if (timeOfDay == null && timeStr.trim().length > 2 && timeStr.indexOf(":") == -1) {
        timeStr = timeStr.slice(0, timeStr.length - 2) + ":" + timeStr.slice(timeStr.length - 2);
      }
      else if (timeStr.length > 4 && timeStr.indexOf(":") == -1) {
        let tempTimeStr = timeStr.toLowerCase();
        tempTimeStr = tempTimeStr.replace(" ", "").replace("am", "").replace("pm", "").trim();
        tempTimeStr = tempTimeStr.slice(0, tempTimeStr.length - 2) + ":" + tempTimeStr.slice(tempTimeStr.length - 2);
        timeStr = tempTimeStr + " " + timeOfDay;
      }
      let timeObj = this.timeParserService.parseTime(timeStr);
      let isValid = timeStr != '' && timeObj != null;
      if (isValid) {
        //Adjust time of new entries based on if the entry was Start or Stop
        if (timeOfDay == null && !this.time24HourMode) {
          if (mode == "StartTime") {
            //hours format
            if (timeStr >= 1 && timeStr <= 5) {
              timeObj.addHours(12);
            }
            //colon format
            let tempTimeStr = timeStr.replace(":", "");
            if (tempTimeStr >= 100 && tempTimeStr <= 559) {
              timeObj.addHours(12);
            }
          }
          else if (mode == "StopTime") {
            //hours format
            if (timeStr >= 1 && timeStr <= 8) {
              timeObj.addHours(12);
            }
            //colon format
            let tempTimeStr = timeStr.replace(":", "");
            if (tempTimeStr >= 100 && tempTimeStr <= 859) {
              timeObj.addHours(12);
            }
          }
        }
        let newTimeStr;
        if (this.time24HourMode)
          newTimeStr = timeObj.toString('HH:mm');
        else
          newTimeStr = timeObj.toString('hh:mm tt');
        if (timeStr != newTimeStr) {
          return newTimeStr
        }
      }
      return timeStr;
    }
    return "";
  }

  public getColumnsForDR() {
    return this.columnsForDR;
  }

  private escapeHtml(unsafe) {
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
}
